import React, {
  useCallback, useContext, useEffect, useState,
} from 'react';
import AdminContainer from 'components/Admin/AdminContainer';
import { useParams, useLocation } from 'react-router';
import handlePromise from 'utils/Promise';
import DocsRequestService from 'services/api/DocsRequest';
import { DocRequestTemplateCategoryType } from 'types/DocRequestTemplate';
import { DocRequestEntity, DocRequestGrouped } from 'types/DocRequest';
import _ from 'lodash';
import { LoadingContext } from 'context/Loading';
import DocsView from './components/View';

function DocsScreen() {
  const { id, type } = useParams();
  const location = useLocation();
  const { toggleLoading } = useContext( LoadingContext );
  const dataLocation:any = location?.state;

  let headerTitle = type === 'inv' ? dataLocation?.nameCuentadeInversion : '';
  headerTitle = type === 'user' ? dataLocation?.fullName : headerTitle;
  headerTitle = type === 'pro' ? dataLocation?.codigoPromocion : headerTitle;

  const [data, setData] = useState<DocRequestGrouped>( {
    [DocRequestTemplateCategoryType.physical]: [],
    [DocRequestTemplateCategoryType.fiscal]: [],
    [DocRequestTemplateCategoryType.investments]: [],
    [DocRequestTemplateCategoryType.titular]: [],
  } );

  const fetchData = useCallback( async () => {
    if ( id ) {
      toggleLoading( true );
      const [, response, responseData] = await handlePromise(
        DocsRequestService.getDocRequests( id ),
      );
      toggleLoading( false );

      if ( response.ok ) {
        const groupedData = _.groupBy( responseData.data, 'categoria' );
        setData( groupedData );
      }
    }
  }, [] );

  useEffect( () => {
    fetchData();
  }, [] );

  const updateItem = useCallback( ( newItem: DocRequestEntity ) => {
    if ( newItem && newItem.categoria ) {
      const category = newItem.categoria as DocRequestTemplateCategoryType;

      setData( ( prev ) => {
        const i = prev[category]?.findIndex( ( item ) => item.id === newItem.id );
        if ( i === -1 ) return prev;
        const newData = JSON.parse( JSON.stringify( prev ) );
        newData[category][i as number] = newItem;
        return newData;
      } );
    }
  }, [data] );

  const submitForm = useCallback( async (
    docId: number,
    field: string,
    value?: string | boolean,
    note?: string,
  ) => {
    if ( ( typeof value === 'string' && value ) || typeof value === 'boolean' ) {
      const dataToSend = {
        nota: note,
        solicitudData: { [field]: value },
      };

      const [errors, response, responseData] = await handlePromise(
        DocsRequestService.editDocRequests( docId, dataToSend ),
      );

      if ( response.ok ) {
        return responseData;
      }
      throw new Error( errors.error );
    }
    return null;
  }, [] );

  const toggleMassiveActive = useCallback( async (
    docsToUpdate: DocRequestEntity[],
    newValue: boolean,
  ) => {
    toggleLoading( true );
    if ( !docsToUpdate?.length ) return;

    const updatePromises = docsToUpdate.map( ( doc ) => submitForm( doc.id, 'activo', newValue )
      .catch( () => undefined ) );

    await Promise.all( updatePromises );
    toggleLoading( false );
    fetchData();
  }, [fetchData] );

  return (
    <AdminContainer
      extraData={dataLocation?.extraData}
      credentialState={dataLocation?.credentialState}
      ssoUserId={dataLocation?.ssoUserId}
      roles={dataLocation?.roles}
      userId={dataLocation?.userId}
      headerTitle={headerTitle}
      id={id ? Number( id ) : undefined}
      type={type}
    >
      <DocsView
        data={data}
        fetchData={fetchData}
        setItem={updateItem}
        toggleMassiveActive={toggleMassiveActive}
      />
    </AdminContainer>
  );
}

export default DocsScreen;
